import React, { useState } from 'react';
import api from '../utils/api';
import heroImage from '../assets/a3532d9a5c1cd9b83f8184c8b0178a92.png'
import Logo from '../assets/layer1.png'
const RegisterMain = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/users/register', {
        fullName,
        email,
        password,
      });
      console.log('Registration successful:', response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-backgroundMain">
      <div className="flex flex-col md:flex-row items-center bg-backgroundMain text-white rounded-lg p-6 max-w-4xl w-full ">
        {/* Form Section */}
        <div className="w-full md:w-1/2 px-6 py-4 ml-56">
          <div className="text-center mb-6">
            <img
              src={Logo}
              alt="Game Icon"
              className="w-12 mx-auto"
            />
            <h2 className="text-primary text-3xl font-bold mt-4">Create Account</h2>
          </div>
          {error && <p className="text-red-500 text-center">{error}</p>}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-primary mb-1">Name</label>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-primary mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-primary mb-1">Password</label>
              <div className="relative">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
                />
              </div>
            </div>
            <button
              type="submit"
              className="w-full bg-primary rounded-lg text-gray-800 font-bold py-2 hover:bg-yellow-500 transition duration-200"
            >
              Sign Up
            </button>
          </form>
          <p className="text-sm mt-4 text-center text-primary">
            Already have an account?{' '}
            <a href="/login" className="text-primary hover:underline">
              Sign in now
            </a>
          </p>
        </div>
      </div>
    </div>

  );

};

export default RegisterMain;
